import { Box } from '@mui/material';
import { useEffect } from 'react';
import BaseModuleProps from '../../../lib/BaseModuleProps';

/**
 * An optional module to provide the user with a survey
 */
const SurveyModule = (props: BaseModuleProps) => {
  useEffect(() => {
    props.setComplete();
  }, [props]);

  return (
    <Box>
      <h1>Survey Module</h1>
    </Box>
  );
};

export default SurveyModule;
